import React from "react";

import BackButtom from "../../../components/backButton";
import FormFactory from "../../../components/form/form-factory";

import * as S from "./styles";

import IFormPage from "../../../interfaces/form-page";

type IProps = any & IFormPage;

const isMobile = window.innerWidth < 768;

const RegisterDeveloperWithoutCompany: React.FC<IProps> = ({
  dataForm,
  onSubmit,
  errorMessage,
  backButton,
}) => (
  <S.Container>
    <BackButtom text="Cadastro novo usuário" />
    <S.FormContainer>
      <FormFactory
        data={dataForm}
        onSubmit={onSubmit}
        submitErrorMessage={errorMessage}
        backButton={backButton}
        optionsExtra={{
          isRegister: !isMobile,
        }}
      />
    </S.FormContainer>
  </S.Container>
);

export default RegisterDeveloperWithoutCompany;
